module.exports = __webpack_public_path__ + "static/media/catherine_crop.cede68af.jpg";